//// Country Dropdown Js ////
function setCookie(name, value) {
    document.cookie = `${name}=${value}`;
}
function handleChange(newValue) {
    setCookie('dark-spot_lastQuestionafter', newValue);
}
function numberChange(lastNumber) {
    setCookie('dark-spot_lastNumber', lastNumber);
}

function findMedication(json, medicationName) {
    if (json.hasOwnProperty(medicationName)) {
      return json[medicationName];
    } else {
        return "Medication not found: " + medicationName;
    }
}
function findMedicationSub(json, medicationName, dosage) {
    if (json.hasOwnProperty(medicationName)) {
      if (json[medicationName].hasOwnProperty(dosage)) {
        return json[medicationName][dosage];
      }
    } else {
        return "Medication not found: " + medicationName;
    }
}

function preferredStrength(location,data) {
  $(location).html("");
   const filteredData = Object.fromEntries(
    Object.entries(data).filter(([key, value]) => key && !(key === "skipStrength" && value === "false"))
  );
  var itemCountList = 0;
  $.each(filteredData, function(key, value) {
    if (key != 'url') {
    itemCountList++;
    if (itemCountList == 1) {
      var charAt = 'A'
    }else if (itemCountList == 2) {
      var charAt = 'B'
    }else if (itemCountList == 3) {
      var charAt = 'C'
    }else if (itemCountList == 4) {
      var charAt = 'D'
    }else if (itemCountList == 5) {
      var charAt = 'E'
    }else if (itemCountList == 6) {
      var charAt = 'F'
    }else if (itemCountList == 7) {
      var charAt = 'G'
    }else if (itemCountList == 8) {
      var charAt = 'H'
    }else if (itemCountList == 9) {
      var charAt = 'I'
    }else if (itemCountList == 10) {
      var charAt = 'J'
    }
    const li = $("<li></li>");
      li.html(`
        <input type="checkbox" class="yes_btn" name="option" value="${key}">
        <label for="${key}">
          <div class="opction_btn_main">
            <div class="key_btn">
              <div class="key_helper">
                <div class="key_btn_content">
                  <span class="key_helper_hint_text">Key</span><span class="key_helper_letter">${charAt}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="checkbox_choice_content">
            <div class="text_textwrapper">${key}</div>
          </div>
          <div class="check_mark">
            <span class="icon-check">
              <i class="fal fa-check"></i>
            </span>
          </div>
        </label>
      `);
      $(location).append(li);
    }
  });
  preferredStrengthClick();
}

function extractNoscriptData(htmlString) {
  // Create a temporary DOM element
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;

  // Find the noscript element
  const noscriptElement = tempDiv.querySelector('noscript.product_urls');
  if (!noscriptElement) {
    console.error('Noscript element not found');
    return;
  }

  // Get the JSON data from the noscript element
  const noscriptContent = noscriptElement.textContent.trim();
  let jsonData;
  try {
    jsonData = JSON.parse(noscriptContent);
  } catch (error) {
    console.error('Failed to parse JSON data from noscript:', error);
    return;
  }

  // Return the parsed JSON data
  return jsonData;
}

function findMedicationDosage(json, medicationName, dosage) {
    if (json.hasOwnProperty(medicationName)) {
        if (json[medicationName].hasOwnProperty(dosage)) {
            return json[medicationName][dosage];
        } else {
            return "Dosage not found for " + medicationName;
        }
    } else {
        return "Medication not found: " + medicationName;
    }
}
function findMedicationDosageSub(json, medicationName, dosage, subDosage) {
    if (json.hasOwnProperty(medicationName)) {
        if (json[medicationName].hasOwnProperty(dosage)) {
            return json[medicationName][dosage][subDosage];
        } else {
            return "Dosage not found for " + medicationName;
        }
    } else {
        return "Medication not found: " + medicationName;
    }
}




function pushValueToCookieArray(key, newValue, afterQuestion, lastNumber) {
  var existingCookieValue = document.cookie.replace(new RegExp("(?:(?:^|.*;\\s*)" + key + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1");
  var existingObject = existingCookieValue ? JSON.parse(decodeURIComponent(existingCookieValue)) : {};

  existingObject.items = existingObject.items || [];
  existingObject.items.push(newValue);

  var expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + 10); 

  var cookieString = key + "=" + encodeURIComponent(JSON.stringify(existingObject)) + "; expires=" + expirationDate.toUTCString() + "; path=/";
  document.cookie = cookieString;
  handleChange(afterQuestion);
  numberChange(lastNumber);
  
}
function getCookie(key) {
  var cookies = document.cookie.split(';');  
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim();
    if (cookie.indexOf(key + '=') === 0) {
      return decodeURIComponent(cookie.substring(key.length + 1));
    }
  }
  return null;
}
function deleteCookie(key) {
  var expirationDate = new Date(0); // Set expiration date to a past date
  var cookieString = key + "=; expires=" + expirationDate.toUTCString() + "; path=/";

  document.cookie = cookieString;
}

$('.trigger-icon-button').on('click touch', function() {
    $(".country_dropdown").addClass("select_dropdown_show");
});

$(document).on('click touch', function(event) {
    if (!$(event.target).parents().addBack().is('.trigger-icon-button')) {
        $('.country_dropdown').removeClass('select_dropdown_show');
    }
});

$('.country_dropdown').on('click touch', function(event) {
    event.stopPropagation();
});

$.getJSON('https://cdn.shopify.com/s/files/1/0425/4197/3660/files/custom-countries.json?v=1784870873', function(data) {
    $(".country_list").empty();
    data.sort(function(a, b) {
        return a.name.localeCompare(b.name);
    });
    $.each(data, function(index, item) {
        var html = `
            <div class="country_select_option">
                <div class="country_select_bg">
                    <div class="country_select_wrapper">
                        <span><img src="${item.flag}" alt="${item.name}" style="max-width:28px;"><div class="country_text">${item.name}</div></span>
                        <div class="select_contentText"><div class="country_code">${item.code}</div></div>
                    </div>
                </div>
            </div>
        `;
        $(".country_list").append(html);
    });
    $('.country_select_option').on("click", function () {
        var image = $(this).find("img").attr("src");
        var code = $(this).find(".country_code").text();
        var country = $(this).find(".country_text").text();
        $(".distribute .trigger-icon-button__StrokeIcon img").attr("src", image);
        $(".country_dropdown").removeClass("select_dropdown_show");
        $(".select_country_box input").attr("data-contry-code", code);
        $("#checkNumber").attr("data-contry-code", code);
        $(".form-selected-answer [data-handle='country-code']").val(code);
        $(".selected-country-name").text(country);
    });
});

$("#search_countries").on("keyup", function() {
    var value = $(this).val().toLowerCase();
    $(".country_list .country_select_option").filter(function() {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)
    });
});

function shakeEffect($selector) {
    $selector.removeClass('shake_animation');
    setTimeout(function() {
        $selector.addClass('shake_animation');
        setTimeout(function() {
            $selector.removeClass('shake_animation');
        }, 600);
    }, 10);
}

$('.dm-data-validate').keypress(function(e) {
    if (e.which == 13) {
        $(this).parents('.form_loop').find('button').click();
    }
    var $limit = parseInt($(this).attr('maxlength'));
    if ($(this).val().length <= $limit) {} else {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

$('.form_loop textarea').keypress(function(e) {
    if (e.which == 13 && !e.shiftKey) {
        $(this).parents('.form_loop').find('button').click();
        return false;
    }
});

$('.dm-data-validate').keyup(function() {
    var d = new Date();
    var $max = parseInt($(this).attr('max')) || d.getFullYear();

    if ($(this).val() > $max) {
        shakeEffect($(this).parents('.form_loop'));
        return false;
    }
});

$('.dm-question').each(function() {
    var $question = $(this).html();
    var $que = $question;
    $que = $que.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    $(this).parents('.form_loop').attr('data-question', $que);
    var $hidden = '<input type="hidden" name="' + $question + '" data-handle="' + $que + '">';
    $('.form-selected-answer').append($hidden);
});

$('.form-selected-answer').append('<input type="hidden" name="country code" data-handle="country-code" value="+61">');
$('.form-selected-answer [data-handle="please-enter-your-medicare-card-details"]').remove();
$('.form-selected-answer [data-handle="what-is-your-ihi"]').remove();


$('.unfortunately_title .back_btn_content button, .book-consiltation-doctor .back_btn_content button').click(function() {
    var Goto = $(this).attr('goto');
    var $indexGoto = $('.form_loop[data-question=' + Goto + ']').index();
    $('.form_loop').removeClass('d-none').removeClass('d-block');

    var $limit = $('.form_loop').length;
    for (i = 0; i < $limit; i++) {
        if (i == $indexGoto) {
            $('.form_loop[data-question=' + Goto + ']').addClass('d-block').animate({
                scrollTop: 0
            });
            break;
        } else {
            var j = i + 1;
            $('.form_loop:nth-child(' + j + ')').addClass('d-none');
        }
    }
});

$('.form_loop input[type=checkbox]').click(function() {
    var Name = $(this).attr('name');
    var $parent = $(this).parents('.form_loop');
    $parent.find('input[name=' + Name + ']:checked').not(this).prop('checked', false);
});

//   FIRST YES BTN
$('.first_questions_section .form_action_btn').click(function() {
    $(this).parents('.form_loop').removeClass('d-block').addClass('d-none').next().addClass('d-block');
    $('.progress_content').show();
    pushHistory(1);
    $('html, body').animate({
      scrollTop: 0
    }, 800);
    var cookieToDelete = 'dark-spot';
    deleteCookie(cookieToDelete);
    deleteCookie("dark-spot_lastQuestionafter");
    $('.form-selected-answer input[type="hidden"]').each(function(){
      $(this).val("");
    })
});

$('.continue_btn_content .continue_action_btn').click(function() {
  var weightLossCookieValue = getCookie('dark-spot_lastQuestionafter');
  var weightLosslatnumCookieValue = getCookie('dark-spot_lastNumber');
  
  if (weightLossCookieValue !== null) {

    $(this).parents('.form_loop').removeClass('d-block').addClass('d-none');
    
    $('.questionnaire_form_main .form_loop').each(function(){
      var selfQuestions = $(this).data('question');
      if(selfQuestions == weightLossCookieValue){
         $(this).addClass('d-block').find('.number').html(weightLosslatnumCookieValue);
      }
    });
  }
});


var que1 = "do-you-have-a-hypersensitivity-to-tretinoin-or-any-of-the-ingredients-in-the-formulation-or-are-you-pregnant-or-breastfeeding";
var que2 = "do-you-have-any-allergies-or-special-medical-conditions";
var que3 = "would-you-like-to-see-treatment-options-now-without-speaking-with-a-doctor";
var que4 = "please-upload-a-photo-of-your-dark-spots";
// var que5 = "would-you-like-to-see-treatment-options-now-without-speaking-with-a-doctor";
var que6 = "how-long-have-you-had-dark-spots";
var que7 = "has-it-ever-been-checked-by-a-gp-or-skin-cancer-doctor";
var que8 = "what-did-your-gp-or-skin-cancer-doctor-say-after-examining-you";
var que9 = "please-enter-your-date-of-birth";
var que10 = "discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id";
var que11 = "based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment";
var que12 = "please-acknowledge-that-you-will-see-your-gp-or-skin-cancer-clinic-for-check-up-or-examination-if-it-does-not-clear-up-in-the-next-2-3-weeks";

var que13 = "please-enter-any-allergies-or-special-medical-conditions";
var que14 = "do-you-take-any-medications";
var que15 = "enter-any-medications-you-take-or-have-previously-taken";

// new question add | 23 Jul start ===============
var que16 = "enter-the-name-of-medication-below";
var que17 = "please-select-your-preferred-strength";
var que18 = "do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues";
var que19 = "please-list-any-regular-medications-you-take-any-known-allergies-or-any-medical-issues";
var que20 = "do-you-have-a-medication-preference";
var que21 = "would-you-like-to-skip-the-questionnaire-and-speak-with-a-doctor-or-nurse-practitioner-instead";

$('.form-selected-answer input[type="hidden"]').each(function(){
  var selfHandle = $(this).attr('data-handle');
  var weightLossCookieValue = getCookie('dark-spot');
  if (weightLossCookieValue !== null) {
      $('.continue_btn_content').removeClass('hidden');
      var weightLossObject = JSON.parse(weightLossCookieValue);
      var weightLossObjectItem = weightLossObject.items;
      for (var i = 0; i < weightLossObjectItem.length; i++) {
      var currentObject = weightLossObjectItem[i];
      for (var key in currentObject) {
        if (currentObject.hasOwnProperty(key)) {
          var cookieValue = currentObject[key];
          if(key == selfHandle){
            $('.form-selected-answer [data-handle=' + key + ']').val(cookieValue);
          }else{
            if($('#callback-form input[data-handle="'+key+'"]').length == 0){
              var getName = $(".form_loop[data-question='"+ key +"' ] .dm-question").text();
              var getQuestion = getName;
              $('.form-selected-answer').append('<input type="hidden" name="'+getQuestion+'" data-handle="'+key+'">');
              $('.form-selected-answer [data-handle=' + key + ']').val(cookieValue);
            }
          }
        }
      }
    }
    
    if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'no' || $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'No'){
        if($('#callback-form input[data-handle="what-is-your-ihi"]').length == 0){ 
          $('.form-selected-answer').append('<input type="hidden" name="What is your IHI?" data-handle="what-is-your-ihi">');
        }
     }else if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'yes' || $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'Yes'){
       if($('#callback-form input[data-handle="please-enter-your-medicare-card-details"]').length == 0){ 
          $('.form-selected-answer').append('<input type="hidden" name="Please enter your Medicare Card details" data-handle="please-enter-your-medicare-card-details">');
          var irnHtml = '<input type="hidden" name="irn_number" data-handle="do-you-have-a-medicare-card_irn">',
              cardNumberHtml = '<input type="hidden" name="medicare-card_number" data-handle="do-you-have-a-medicare-card_number">',
              monthYearHtml = '<input type="hidden" name="medicare-card_month_year" data-handle="do-you-have-a-medicare-card_month_year">';
          $('.form-selected-answer').append([irnHtml, cardNumberHtml, monthYearHtml]);
       }
     }
    
  }
});

var json;
function handleResponse() {
    const data = JSON.parse(this.responseText);
    const extractedData = extractNoscriptData(data['search-product-list-6']);
    json = extractedData;
    var medication = $('.form-selected-answer [data-handle=' + que16 + ']').val();
    var getData = findMedication(json, medication);
    preferredStrength($(".form_loop[data-question='please-select-your-preferred-strength'] .maintaining_option ul"),getData);
}

const request = new XMLHttpRequest();
request.addEventListener('load', handleResponse);
request.open('GET', 'https://bursthealth.com.au/pages/product-search-data?sections=search-product-list-6', true);
request.send();



$('.form_loop[data-question=' + que21 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que21 + ']').val($this.val());
          if ($this.val() == 'Yes') {
            
            var newValue = { 'would-you-like-to-skip-the-questionnaire-and-speak-with-a-doctor-or-nurse-practitioner-instead': $this.val()};
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
            $('.form_loop[data-question="discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id"]').addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $('.form_loop[data-question="discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id"]').data("question");
            pushHistory($currentNumber + 1);
            CalculateP();
            
          }else {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
            $('.form_loop[data-question="do-you-have-a-hypersensitivity-to-tretinoin-or-any-of-the-ingredients-in-the-formulation-or-are-you-pregnant-or-breastfeeding"]').addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-hypersensitivity-to-tretinoin-or-any-of-the-ingredients-in-the-formulation-or-are-you-pregnant-or-breastfeeding"]').data("question");
          }
          
            pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});



function weightLossQestion() {
  $('.form_loop[data-question=' + que16 + '] .custom_select_button').click(function() {
      ValidateRemove();
      var $this = $(this),
          $parent = $this.parents('.form_loop'),
          $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        console.log(this,`$(".search-bar:not(.drawer) .predictive-search")$(".search-bar:not(.drawer) .predictive-search")`)
          $('.form-selected-answer [data-handle=' + que16 + ']').val($this.val());
          var medication = $this.val();
          var getData = findMedication(json, medication);
          var newValue = { 'enter-the-name-of-medication-below': $this.val()};
        
            if (getData.skipStrength == "true") {
              $('#callback-form').submit();
              var afterlastQuestion = "";
            } else {
              preferredStrength($(".form_loop[data-question='please-select-your-preferred-strength'] .maintaining_option ul"),getData)
              $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
              var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            }
            pushHistory($currentNumber + 1);
            CalculateP();
              pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1);
      }, 100);
  });
}


setTimeout(()=>{
  weightLossQestion();
}, 4000);


function preferredStrengthClick() {
$('.form_loop[data-question=' + que17 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {      
      if ($parent.find('input[name=' + Name + ']:checked').length) {
          $('.form-selected-answer [data-handle=' + que17 + ']').val($this.val());

        if ($this.val() == '40 Mg') {
          $('.form-selected-answer').append('<input type="hidden" name="Have you taken 40mg before?" data-handle="have-you-taken-40mg-before">');          
          var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
        }else {
          $('#callback-form').submit();
        }
           var newValue = { 'please-select-your-preferred-strength': $this.val()};
              pushHistory($currentNumber + 1);
              CalculateP();
          pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1);
      }
    }, 100);
});
}
preferredStrengthClick();

$('.form_loop[data-question=' + que18 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que18 + ']').val($this.val());
           var newValue = { 'do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues': $this.val()};
          if ($this.val() == 'Yes') {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          }else {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
            $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').data("question");
          }
          
            pushHistory($currentNumber + 1);
            CalculateP();
            pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});


$('.form_loop[data-question=' + que19 + '] button').click(function() {
      ValidateRemove();  
      var $this = $(this),
          Name = $this.attr('name'),
          $parent = $this.parents('.form_loop'),
          $currentNumber = parseInt($parent.find('.number').html()),
          $value = $parent.find('textarea').val(),
          $value = $value.trim();
      if ($value.length) {
          $('.form-selected-answer [data-handle=' + que19 + ']').val($value);
          var newValue = { 'please-list-any-regular-medications-you-take-any-known-allergies-or-any-medical-issues': $value };
          $this.parents('.form_loop').addClass('d-none').removeClass('d-block')
          $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').addClass('d-block').find('.number').html($currentNumber + 1);
          var afterlastQuestion = $('.form_loop[data-question="based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment"]').data("question");
        
          pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1);  
          pushHistory($currentNumber + 1);
          CalculateP();
      } else {
          shakeEffect($parent);
          $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
          setTimeout(function() {
              $('.valid_date_text').remove();
          }, 2500);
      }
  });
$('.form_loop[data-question=' + que20 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que20 + ']').val($this.val());
          if ($this.val() == 'Yes') {
            var newValue = { 'do-you-have-a-medication-preference': $this.val()};
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
          }else {
            $('#callback-form').submit();
            var afterlastQuestion = "";
          }
          
            pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1);
        }
      }, 100);
});




//  STEP 1
$('.form_loop[data-question=' + que1 + '] .form_action_btn, .form_loop[data-question=' + que1 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val();

            var newValue = { 'do-you-have-a-hypersensitivity-to-tretinoin-or-any-of-the-ingredients-in-the-formulation-or-are-you-pregnant-or-breastfeeding': $value };
          
            if ($value == "Yes") {
                CalculateP();
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                $('.unfortunately_title').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                $('.progress_content .progress_title span').html('100');
                $('#form_progress_bar').css('width', '100%');
            } else {
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                $('.form-selected-answer [data-handle=' + que1 + ']').val($value);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $parent.next().data("question");
                pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1);  
            }
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

//  STEP 2
$('.form_loop[data-question=' + que2 + '] .form_action_btn, .form_loop[data-question=' + que2 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val();
                var newValue = { 'do-you-have-any-allergies-or-special-medical-conditions': $value };
            if ($value == "Yes") {
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $parent.next().data("question");
            } else {
                $parent.removeClass('d-block').addClass('d-none').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $parent.next().next().data("question");
            }
            pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1); 
            CalculateP();
            $('.form-selected-answer [data-handle=' + que2 + ']').val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});
$('.form_loop[data-question=' + que13 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que13 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'please-enter-any-allergies-or-special-medical-conditions': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});
$('.form_loop[data-question=' + que14 + '] .form_action_btn, .form_loop[data-question=' + que14 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);
    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val();

                var newValue = { 'do-you-take-any-medications': $value };

            if ($value == "Yes") {
                $parent.removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $parent.next().data("question");
            } else {
                $parent.removeClass('d-block').addClass('d-none').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $parent.next().data("question");
            }
            pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1); 
            CalculateP();
            $('.form-selected-answer [data-handle=' + que14 + ']').val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});
$('.form_loop[data-question=' + que15 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que15 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'enter-any-medications-you-take-or-have-previously-taken': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 3
$('.form_loop[data-question=' + que3 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que3 + ']').val($this.val());
            var newValue = { 'would-you-like-to-see-treatment-options-now-without-speaking-with-a-doctor': $this.val() };
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
                $('.book-consiltation-doctor').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
                pushHistory($currentNumber + 1);
                CalculateP();
                var afterlastQuestion = $('.book-consiltation-doctor').data("question");
            }
            pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1); 
        }
    }, 500);
});

// STEP 4
$('.form_loop[data-question='+que4+'] .form_next_btn button').click(function(){
  console.log('1111');
  ValidateRemove();
  var $this = $(this),
      $parent = $this.parents('.form_loop'),
      $currentNumber = parseInt($parent.find('.number').html());

  console.log($currentNumber,'$currentNumber');
  if ($parent.find('.Customer_details_content input.profile_url_hidden').val() != ''){
  	$parent.addClass('d-none').removeClass('d-block').next().addClass('d-block');
    var urlval = $parent.find('.Customer_details_content input.profile_url_hidden').val();	
    $('.form-selected-answer [data-handle='+que4+']').val(urlval);
    var newValue = { 'please-upload-a-photo-of-your-dark-spots': urlval };
    var afterlastQuestion = $parent.next().data("question");
    pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1); 
    $parent.next().find('.number').html($currentNumber + 1);
  }
  else {
  	shakeEffect($parent);
    $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
    setTimeout(function(){ $('.valid_date_text').remove(); },2500);
  }
});

//  STEP 5
// $('.form_loop[data-question=' + que5 + '] button').click(function() {
//     ValidateRemove();
//     var $this = $(this),
//         Name = $this.attr('name'),
//         $parent = $this.parents('.form_loop'),
//         $currentNumber = parseInt($parent.find('.number').html()),
//         $value = $parent.find('textarea').val(),
//         $value = $value.trim();
//     if ($value.length) {
//         $('.form-selected-answer [data-handle=' + que5 + ']').val($value);
//         setTimeout(function() {
//             $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
//             pushHistory($currentNumber + 1);
//             CalculateP();
//         }, 500);
//     } else {
//         shakeEffect($parent);
//         $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
//         setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
//     }
// });

//  STEP 6
$('.form_loop[data-question=' + que6 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que6 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'how-long-have-you-had-dark-spots': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

//  STEP 7
$('.form_loop[data-question=' + que7 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
            $('.form-selected-answer [data-handle=' + que7 + ']').val($this.val());
            var newValue = { 'has-it-ever-been-checked-by-a-gp-or-skin-cancer-doctor': $this.val() };
            if ($this.val() == 'Yes') {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            } else {
                $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $this.parents('.form_loop').next().next().data("question");
            }
            pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1); 
            pushHistory($currentNumber + 1);
            CalculateP();
        }
    }, 500);
});

//  STEP 12
$('.form_loop[data-question=' + que12 + '] input[type=checkbox]').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      setTimeout(function() {
        if ($parent.find('input[name=' + Name + ']:checked').length) {
          $('.form-selected-answer [data-handle=' + que12 + ']').val($this.val());
          var newValue = { 'please-acknowledge-that-you-will-see-your-gp-or-skin-cancer-clinic-for-check-up-or-examination-if-it-does-not-clear-up-in-the-next-2-3-weeks': $this.val() };
          if ($this.val() == 'Yes') {
              $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
              var afterlastQuestion = $this.parents('.form_loop').next().data("question");
              pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1); 
          } else {
              $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
              $('.unfortunately_title').addClass('d-block').removeClass('d-none').find('.back_btn_content button').attr('goto', $parent.data('question'));
          }
          pushHistory($currentNumber + 1);
          CalculateP();
        }
      }, 500);
});

//  STEP 8
$('.form_loop[data-question=' + que8 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que8 + ']').val($value);
        setTimeout(function() {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'what-did-your-gp-or-skin-cancer-doctor-say-after-examining-you': $value };
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 9
$('.form_loop[data-question=' + que9 + '] .form_action_btn').click(function() {
    ValidateRemove();
    $('.dm-error').remove();
    var $MM = $('.birth_date_field .month input').val(),
        $DD = $('.birth_date_field .day input').val(),
        $YY = $('.birth_date_field .year input').val();
    var InputDate = new Date($MM + '/' + $DD + '/' + $YY);
    var Today = new Date();
    var $currentNumber = parseInt($(this).parents('.form_loop').find('.number').html());

    var Difference_In_Time = Today.getTime() - InputDate.getTime();

    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24 * 365);

    if (Difference_In_Days >= 18 && ($MM.length <= 2 && $DD.length <= 2 && $YY.length == 4)) {

      if ($('.form-selected-answer [data-handle=' + que21 + ']').val() == 'Yes') {
        $(this).parents('.form_loop').addClass('d-none').removeClass('d-block');
        $('.form_loop[data-question="do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues"]').addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $('.form_loop[data-question="do-you-take-any-regular-medications-have-any-known-allergies-or-any-medical-issues"]').data("question");
      }else {
        $(this).parents('.form_loop').removeClass('d-block').addClass('d-none').next().addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $(this).parents('.form_loop').next().data("question");
      }
      
        pushHistory($currentNumber + 1);
        $('.form-selected-answer [data-handle=' + que9 + ']').val($DD + '/' + $MM + '/' + $YY);
        CalculateP();
        var newValue = { 'please-enter-your-date-of-birth': $DD + '/' + $MM + '/' + $YY };
        pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1); 
    } else {
        shakeEffect($(this).parents('.form_loop'));
        $($('#error-template').html()).insertAfter($(this).parents('.form_loop').find('.birth_date_field'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 10
$('.form_loop[data-question=' + que10 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        Name = $this.attr('name'),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('textarea').val(),
        $value = $value.trim();
    if ($value.length) {
        $('.form-selected-answer [data-handle=' + que10 + ']').val($value);
        setTimeout(function() {


          if ($('.form-selected-answer [data-handle=' + que21 + ']').val() == 'Yes') {
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
            $('.form_loop[data-question="please-enter-your-date-of-birth"]').addClass('d-block').find('.number').html($currentNumber + 1);
            var afterlastQuestion = $('.form_loop[data-question="please-enter-your-date-of-birth"]').data("question");
          }else { 
            var afterlastQuestion = $this.parents('.form_loop').next().data("question");
            $this.parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);
          }
      
        
            pushHistory($currentNumber + 1);
            CalculateP();
            var newValue = { 'discretion-is-at-the-heart-of-what-we-do-but-for-legal-reasons-the-name-on-your-prescription-must-be-your-full-legal-name-please-provide-your-legal-name-as-per-your-official-government-id': $value };
            pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1); 
        }, 500);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP 11
$('.form_loop[data-question=' + que11 + '] button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
    if ($parent.find('.select_country_box input').val().length > 9) {
        $this.attr('disabled', 'disabled');
        var Value = $parent.find('.select_country_box input').val(),
            Ccode = $parent.find('.select_country_box input').data('contry-code');

        $('.form-selected-answer [data-handle=country-code]').val(Ccode);
        $('#checkNumber').val(Value);
        $('#confirmation_popup').toggle();
        CalculateP();
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }

});


function otpAfterClick() {
$('#confirmation_popup .confirm_button').click(function(){
   var checkVal = $(this).parents('#confirmation_popup').find('#checkNumber').val();
   var $currentNumber = parseInt($('.form_loop[data-question=' + que11 + ']').find('.number').html());
   if (checkVal.length > 9) {
    $('#confirmation_popup').toggle();

     if ($('.form-selected-answer [data-handle=' + que21 + ']').val() == 'Yes') {
        $('.form_loop[data-question=' + que11 + '] button').parents('.form_loop').addClass('d-none').removeClass('d-block')
        $('.form_loop[data-question="do-you-have-a-medicare-card"]').addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medicare-card"]').data("question");
     }else{
        $('.form_loop[data-question=' + que11 + '] button').parents('.form_loop').addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1)
        var afterlastQuestion = $('.form_loop[data-question=' + que11 + '] button').parents('.form_loop').next().data("question");
     }
     
     
    $('.form-selected-answer [data-handle=' + que11 + ']').val(checkVal);
    $('.form_loop[data-question=' + que11 + '] button').find('input').val(checkVal);
    var newValue = { 'based-on-your-medical-history-and-individual-needs-our-doctors-have-provided-personalised-treatment-please-complete-your-mobile-phone-number-to-view-recommended-treatment': checkVal };
    pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1); 
   }else {
      $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
      setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
      shakeEffect($parent);
   }
})
}
otpAfterClick()

// STEP ?
$('.form_loop[data-question="do-you-have-a-medicare-card"] .maintaining_option input[type=checkbox]').click(function() {
    ValidateRemove();
    var $parent = $(this).parents('.form_loop'),
        $this = $(this);

    setTimeout(function() {
        if ($parent.find('input[type=checkbox]:checked').length) {
            var $currentNumber = parseInt($parent.find('.number').html()),
                $value = $parent.find('input[type=checkbox]:checked').val();

                var newValue = { 'do-you-have-a-medicare-card': $value };

            if ($value == "yes" || $value == "Yes") {
                $parent.addClass('d-none').removeClass('d-block').next().addClass('d-block').find('.number').html($currentNumber + 1);

                var irnHtml = '<input type="hidden" name="irn_number" data-handle="do-you-have-a-medicare-card_irn">',
                    cardNumberHtml = '<input type="hidden" name="medicare-card_number" data-handle="do-you-have-a-medicare-card_number">',
                    monthYearHtml = '<input type="hidden" name="medicare-card_month_year" data-handle="do-you-have-a-medicare-card_month_year">';

                $('.form-selected-answer').append('<input type="hidden" name="Please enter your Medicare Card details" data-handle="please-enter-your-medicare-card-details">');
                $('.form-selected-answer').append([irnHtml, cardNumberHtml, monthYearHtml]);
                var afterlastQuestion = $parent.next().data("question");

            } else {
                $('.form-selected-answer').append('<input type="hidden" name="What is your IHI?" data-handle="what-is-your-ihi">');
                $parent.addClass('d-none').removeClass('d-block').next().next().addClass('d-block').find('.number').html($currentNumber + 1);
                var afterlastQuestion = $parent.next().next().data("question");
            }
            pushValueToCookieArray('dark-spot', newValue, afterlastQuestion, $currentNumber + 1); 
            $('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val($value);
            pushHistory($currentNumber + 1);
            CalculateP();
        } else {
            $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
            shakeEffect($(this).parents('.form_loop'));
        }
    }, 500);
});

// STEP ??
$('.form_loop[data-question="please-enter-your-medicare-card-details"] .form_submit_btn button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html());
      

    var $MM = $('.card_years_field .month input').val(),
        $YY = $('.card_years_field .year input').val(),
        $INR = $parent.find('.details_filed input.enter_irn_number').val(),
        $CardNumber = $parent.find('.details_filed input.enter_card_number').val();

    if ($parent.find('.details_filed input.enter_irn_number').val().length == 1 && $parent.find('.details_filed input.enter_card_number').val().length == 10  && $MM <= 12 && $MM != '' && $YY != '') {
        $parent.addClass('d-none').removeClass('d-block');
        $('.neurological_que[data-question="appoinment"]').addClass('d-block');
        $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_irn"]').val($INR);
        $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_number"]').val($CardNumber);
        $('.form-selected-answer [data-handle="do-you-have-a-medicare-card_month_year"]').val(`${$MM}/${$YY}`);

        var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medication-preference"]').data("question");

        var newValue = { 'do-you-have-a-medicare-card_irn': $INR };
                    pushValueToCookieArray('dark-spot', newValue,afterlastQuestion);
  
        var newValue = { 'do-you-have-a-medicare-card_number': $CardNumber };
                    pushValueToCookieArray('dark-spot', newValue,afterlastQuestion);
  
        var newValue = { 'do-you-have-a-medicare-card_month_year': $MM+ "/" +$YY };
                    pushValueToCookieArray('dark-spot', newValue,afterlastQuestion, $currentNumber + 1);

        $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
        $('.form_loop[data-question="do-you-have-a-medication-preference"]').addClass('d-block').find('.number').html($currentNumber + 1);


      
        CalculateP();
        // $('#callback-form').submit();
    } else {
        shakeEffect($parent);
        // errorPopUp();
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});

// STEP ???
$('.form_loop[data-question="what-is-your-ihi"] .form_submit_btn button').click(function() {
    ValidateRemove();
    var $this = $(this),
        $parent = $this.parents('.form_loop'),
        $currentNumber = parseInt($parent.find('.number').html()),
        $value = $parent.find('.details_filed input').val();
    if ($value != '') {
        $parent.addClass('d-none').removeClass('d-block');
        CalculateP();
        $('.form-selected-answer [data-handle="what-is-your-ihi"]').val($value);
        // $('#callback-form').submit();
      
        $this.parents('.form_loop').addClass('d-none').removeClass('d-block');
        $('.form_loop[data-question="do-you-have-a-medication-preference"]').addClass('d-block').find('.number').html($currentNumber + 1);
        var afterlastQuestion = $('.form_loop[data-question="do-you-have-a-medication-preference"]').data("question");
        var newValue = { 'what-is-your-ihi': $value };
        pushValueToCookieArray('dark-spot', newValue,afterlastQuestion, $currentNumber + 1);
    } else {
        shakeEffect($parent);
        $($('#error-template-input').html()).insertAfter($parent.find('textarea'));
        setTimeout(function() { $('.valid_date_text').remove(); }, 2500);
    }
});


var $Form = $('#callback-form');
$Form.submit(function(e) {
    e.preventDefault();
    $('.loading-wrapper').show();
    ga('send', 'event', { eventCategory: 'dark-spots', eventAction: 'Submit', eventLabel: 'Dark spots form', eventValue: 1 });

    $Form.find("input[type='hidden']").each(function() {
      var get_data_handle = $(this).attr('data-handle');
  
      if(get_data_handle=='please-enter-your-medicare-card-details'){
          if($('.form-selected-answer [data-handle="do-you-have-a-medicare-card"]').val() == 'no'){
            if($(this).val() == ""){
              $(this).remove();
            }    
          }
      }else{
        if($(this).val() == ""){
          $(this).remove();
        }
      }
      
    })


    if ($('.form-selected-answer [data-handle=' + que20 + ']').val() == 'No') {
      var redirectionMainUrl = json['do-you-have-a-medication-preference-dark-spots'];
    }else{
      var medicationO = $('.form-selected-answer [data-handle=' + que16 + ']').val();
      var getDataO = findMedication(json, medicationO);
      
      if (getDataO.skipStrength == "true") {
        
        var redirectionMainUrl = getDataO.skipDirectUrl;
        
      }else {
      
        const medication = $('.form-selected-answer [data-handle=' + que16 + ']').val();
        const dosage = $('.form-selected-answer [data-handle=' + que17 + ']').val();
        var getData = findMedicationDosage(json, medication, dosage);
        var redirectionMainUrl = getData.url;
      }
    }

    var noscriptContent = $('#productString_url').html();
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    var urls = noscriptContent.match(urlRegex);
    
    $('.form-selected-answer').append(`<input type="hidden" name="Product redirection Url" value="${redirectionMainUrl}">`);
    $('.form-selected-answer').append(`<input type="hidden" name="Product Session id" value="${unique_id}">`);
    $.each(urls, function(index, url) {
     if (url.includes(redirectionMainUrl) || redirectionMainUrl.includes(url)) {
      $('.form-selected-answer').append(`<input type="hidden" name="Product String Url" value="true">`);
     }
    });

    $.ajax({
        url: $Form.attr('action'),
        cache: false,
        type: 'post',
        data: $Form.serialize(),
        success: function(itemData) {
            var data = JSON.parse(itemData);
            jQuery.post('/cart/update.js', "attributes[weightloss-uid]=" + data.unique_id);
            location.href = data.product_link;

            var cookieToDelete = 'dark-spot';
            deleteCookie(cookieToDelete);
            deleteCookie("dark-spot_lastQuestionafter");

        },
        error: function() {
            location.href = 'https://bursthealth.com.au/products/dark-spots';
        }
    });
});


function CalculateP() {
    var Length = $('.form-selected-answer input').length + 1,
        AnswerLength = 0,
        Percentage = 0;
    for (i = 1; i < Length; i++) {
        if ($('.form-selected-answer input:nth-child(' + i + ')').val() != '') {
            AnswerLength = parseInt(AnswerLength) + 1;
        }
    }
    Percentage = parseInt(AnswerLength / $('.form-selected-answer input').length * 100);
    $('.progress_content .progress_title span').html(Percentage);
    $('#form_progress_bar').css('width', Percentage + '%');
}

function pushHistory(number) {
    window.history.pushState("", "", location.pathname + "?question=" + number);
    ga('send', {
        hitType: 'pageview',
        page: location.pathname + location.search
    });
}

function ValidateRemove() {
    $('.form_loop .valid_date_text').remove();
}

// Upload Image Content
var video1 = document.querySelector("#videoElement");
$('#enable_camera_profile').click(function(){
	if (navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: true })
      .then(function (stream) {
        window.localStream = stream;
        video1.srcObject = stream;
        $('#videoElement').show();
        $('#snap_profile').show();
        $('#enable_camera_profile').hide();
        $('#profile_normal_image').hide();
        $('#profile_blah').hide();
      })
      .catch(function (err0r) {
        alert('Web cam not detected');
      });
      
    }
});



$('#retake_profile').click(function(){
  	if (navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: true })
      .then(function (stream) {
        window.localStream = stream;
        video1.srcObject = stream;
        $('#snap_profile').show();
        $('.Profile_Canvas').hide();
        $('#videoElement').show();
        $('#retake_profile').hide();
        $('#profile_normal_image').hide();
        $('#profile_blah').hide();
      })
      .catch(function (err0r) {
        alert('Web cam not detected');
      });
    }
});


    var video = document.querySelector('.question_video');
    var canvas2 = document.querySelector('.Profile_Canvas');
    var context = canvas2.getContext('2d');
    var w, h, ratio;


    video.addEventListener('loadedmetadata', function() {
        ratio = video.videoWidth / video.videoHeight;
        w = video.videoWidth - 100;
        h = parseInt(w / ratio, 10);
        canvas2.width = w;
        canvas2.height = h;
    }, false);

    function snaps() {
        context.fillRect(0, 0, w, h);
        context.drawImage(video, 0, 0, w, h);

        var canvas_img_data1 = canvas2.toDataURL('image/png');
        var img_data1 = canvas_img_data1.replace(/^data:image\/(png|jpg);base64,/, "");
        $('#Profile_ScreenshotImage').html(img_data1);
      	$('#profile_file_type').val('screenshot');
        $('.Profile_Canvas').show();
        $('#videoElement').hide();
        $('#retake_profile').show();
        $('#snap_profile').hide();
        localStream.getVideoTracks()[0].stop();
		$('#Profile_Upload').val('');
      	$('#Submit_Profile_btn').removeAttr('disabled');
      	$('#Submit_Profile_btn').html('Upload');
      	$('#profile_normal_image').hide();
  		$('#profile_blah').hide();
      	upload_image('profile');
    }



Profile_Upload.onchange = evt => {
  const [file] = Profile_Upload.files
  if (file) {
    console.log(file.size);
      profile_blah.src = URL.createObjectURL(file)
        	
      $('#profile_file_type').val('upload_file');
      $('.Profile_Canvas').hide();
      $('#videoElement').hide();
      $('#retake_profile').hide();
      $('#snap_profile').hide();
      $('#Profile_ScreenshotImage').val('');
      $('#Submit_Profile_btn').removeAttr('disabled');
      $('#Submit_Profile_btn').html('Upload');

      $('#profile_normal_image').hide();
      $('#profile_blah').show();
      upload_image('profile');
  }
}

$('#upload_profile, #select_photo').click(function(){
  $('#Profile_Upload').click();
});

$('#upload_profile_address').click(function(){
	$('#address_Profile_Upload').click();
});



// Proof Upload
var video2 = document.querySelector("#proof_videoElement");
$('#enable_camera_proof').click(function(){
	if (navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: true })
      .then(function (stream) {
        window.localStream = stream;
        video2.srcObject = stream;
        $('#proof_videoElement').show();
        $('#snap_proof').show();
        $('#proof_normal_image').hide();
        $('#proof_blah').hide();
      })
      .catch(function (err0r) {
        alert('Web cam not detected');
      });
      
    }
});



$('#retake_proof').click(function(){
  	if (navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices.getUserMedia({ video: true })
      .then(function (stream) {
        window.localStream = stream;
        video1.srcObject = stream;
        $('#snap_proof').show();
        $('.proof_Canvas').hide();
        $('#proof_videoElement').show();
        $('#retake_proof').hide();
        $('#proof_normal_image').hide();
        $('#proof_blah').hide();
      })
      .catch(function (err0r) {
        alert('Web cam not detected');
      });
    }
});

$('#Proof_Upload').change(function(){
  	$('#proof_file_type').val('upload_file');
	$('.proof_Canvas').hide();
  	$('#enable_camera_proof').show();
  	$('#proof_videoElement').hide();
    $('#retake_proof').hide();
    $('#snap_proof').hide();
  	$('#Proof_ScreenshotImage').val('');
    
    $('#proof_normal_image').hide();
    $('#proof_blah').show();
  	upload_image('proof');
});

$('#upload_proof').click(function(){
	$('#Proof_Upload').click();
});




function upload_image(type){
  var url = 'https://bursthealthcare.com/api/upload_image_cloud';

  if(type=='profile'){
    var file_type = $('#profile_file_type').val(); 
    if(file_type=='upload_file' || file_type=='screenshot'){
      var file_data = $('#Profile_Upload').prop('files')[0];   
      var textareaval = $('#Profile_ScreenshotImage').val();
      var formDataToUpload = new FormData();                  
      formDataToUpload.append('file', file_data);
      formDataToUpload.append('screenshot', textareaval); 
      formDataToUpload.append('file_type', file_type); 
      formDataToUpload.append('type', type);
      formDataToUpload.append('que_type', 'dark_spot');

      $.ajax({
        url:url,
        type:"POST",
        contentType:false,
        processData:false,
        data:formDataToUpload,
        beforeSend: function () {
          $('#upload_profile').attr('disabled','disabled');
          $('#upload_profile').html('Please wait..');
        },
        success:function(result){
          var result = JSON.parse(result);
          if(result.error_status!=''){
            alert(result.error_status);
            $('#upload_profile').html('Select Photo');
            $('#upload_profile').removeAttr('disabled');
          }else{
            if(result.url!=null){
              $('.profile_url_hidden').val(result.url); 
              $('.form-selected-answer [data-handle='+que4+']').val(result.url);
              $('#upload_profile').html('Done');
             $('.profile_upload_next').click();             
            }
          }
        }
      });
    }
  }
  
  if(type=='proof'){
    var file_type = $('#proof_file_type').val(); 
    if(file_type=='upload_file' || file_type=='screenshot'){
      var file_data = $('#Proof_Upload').prop('files')[0];   
      var textareaval = $('#Proof_ScreenshotImage').val();
      var formDataToUpload = new FormData();                  
      formDataToUpload.append('file', file_data);
      formDataToUpload.append('screenshot', textareaval); 
      formDataToUpload.append('file_type', file_type); 
      formDataToUpload.append('type', type); 

      $.ajax({
        url:url,
        type:"POST",
        contentType:false,
        processData:false,
        data:formDataToUpload,
        beforeSend: function () {
          $('#upload_proof').attr('disabled','disabled');
          $('#upload_proof').html('Please wait..');
        },
        success:function(result){
          var result = JSON.parse(result);
          if(result.url!=null){
            $('.proof_url_hidden').val(result.url); 
            $('#upload_proof').html('Done');
            $('.proof_upload_next').click();
          }
        }
      });
    }
  }
}


function onmaxlength(e) {
    // var $this = $(e);
    // var maxlength = $this.attr('maxlength');
    // var value = $(e).val();
    // if (value && value.length >= maxlength) {
    //   return false;
    // }else{
    //   return true;
    // }
}